import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MessageNote from "../messageNote/index";

class Note extends Component {
  static propTypes = {
    auth: PropTypes.object,
    accountantSelected: PropTypes.string,
    accountantIdSelected: PropTypes.string,
    companySelected: PropTypes.string,
    clientIdSelected: PropTypes.string,
    detailsDocument: PropTypes.object,
    myType: PropTypes.string
  };

  render() {
    const {
      detailsDocument: { info },
      myType
    } = this.props;

    return info.details ? (
      <div>
        <MessageNote
          docID={info.details.documentId}
          notes={info.details.notes}
          typeAccount={myType}
          scope="document-list"
        />
      </div>
    ) : null;
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    detailsDocument: state.detailsDocument
  };
}

export default connect(mapStateToProps, null)(Note);
